export function formatDateTime (dateString) {
    if(dateString && dateString != ""){
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('en-US',{month:'2-digit', day:'2-digit', year:'2-digit', hour:'numeric', minute:'numeric', hourCycle: 'h12'}).format(date);
    } else {
        return 'None'
    }
}

// Same as formatDateTime, down to the second. Used where the exact moment
// matters -- a back-and-forth on a request reads as a conversation, and
// two replies in the same minute are otherwise indistinguishable.
export function formatDateTimeWithSeconds (dateString) {
    if(dateString && dateString != ""){
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('en-US',{month:'2-digit', day:'2-digit', year:'2-digit', hour:'numeric', minute:'numeric', second:'numeric', hourCycle: 'h12'}).format(date);
    } else {
        return 'None'
    }
}

// "Friday 10/23/2026 4:38:53pm" -- a named day, a four-digit year, and no
// commas. Used wherever a thread is read as a conversation: on a page where
// people are answering each other, "what day was that" is a question the
// numbers alone make you work out.
//
// Assembled from parts rather than formatted whole, because no combination
// of Intl options produces this: asking for a weekday puts a comma after it
// and another before the time, and the day period arrives as "PM".
export function formatDateTimeWithDay (dateString) {
    if (!dateString || dateString === '') return 'None'
    const date = new Date(dateString)
    if (Number.isNaN(date.getTime())) return 'None'
    const part = {}
    const formatter = new Intl.DateTimeFormat('en-US', {
        weekday: 'long', month: '2-digit', day: '2-digit', year: 'numeric',
        hour: 'numeric', minute: '2-digit', second: '2-digit', hourCycle: 'h12',
    })
    for (const piece of formatter.formatToParts(date)) part[piece.type] = piece.value
    const clock = `${part.hour}:${part.minute}:${part.second}`
    // Narrow no-break space in some ICU builds, ordinary space in others --
    // stripped either way so the result does not depend on the browser.
    const period = (part.dayPeriod || '').toLowerCase().replace(/\s/gu, '')
    return `${part.weekday} ${part.month}/${part.day}/${part.year} ${clock}${period}`
}
